import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="w-full py-4 px-4 bg-white/80 border-t">
            <div className="max-w-7xl mx-auto text-center text-sm text-gray-500">
                <p>© {new Date().getFullYear()} 口令树洞. </p>
                <p className="mt-1">
                    <a 
                        href="https://beian.miit.gov.cn/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="hover:text-gray-700"
                    >
                        鄂ICP备2023017820号-5
                    </a>
                </p>
            </div>
        </footer>
    );
};

export default Footer; 